/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    allSaved: "All changes were saved",
    clearBtn: {
        label: "Force data reload"
    },
    offline: "Offline - All changes were saved",
    pending: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "Pending "
    + container.escapeExpression((lookupProperty(helpers,"pluralCount")||(depth0 && lookupProperty(depth0,"pluralCount"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"actionCount") : depth0),"action",{"name":"pluralCount","hash":{},"data":data,"loc":{"start":{"line":1,"column":8},"end":{"line":1,"column":44}}}))
    + " with "
    + container.escapeExpression((lookupProperty(helpers,"pluralCount")||(depth0 && lookupProperty(depth0,"pluralCount"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"operationCount") : depth0),"modification",{"name":"pluralCount","hash":{},"data":data,"loc":{"start":{"line":1,"column":50},"end":{"line":1,"column":95}}}))
    + "...";
},"useData":true}),
    redo: "Redo",
    refreshBtn: {
        label: "Refresh"
    },
    sending: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "Saving "
    + container.escapeExpression((lookupProperty(helpers,"pluralCount")||(depth0 && lookupProperty(depth0,"pluralCount"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"actionCount") : depth0),"action",{"name":"pluralCount","hash":{},"data":data,"loc":{"start":{"line":1,"column":7},"end":{"line":1,"column":43}}}))
    + " with "
    + container.escapeExpression((lookupProperty(helpers,"pluralCount")||(depth0 && lookupProperty(depth0,"pluralCount"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"operationCount") : depth0),"modification",{"name":"pluralCount","hash":{},"data":data,"loc":{"start":{"line":1,"column":49},"end":{"line":1,"column":94}}}))
    + "...";
},"useData":true}),
    undo: "Undo"
};